// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AdminPanelSettingsOutlined } from '@/constants/hardfin-standard-icons';
import { InputAdornment, Tooltip } from '@mui/material';

interface Props {
  /**
   * The tooltip message to display when hovering over the shield icon.
   *
   * @default "This setting is only visible to admins"
   */
  tooltipMessage?: string;
}

/**
 * An input adornment component that displays a shield icon with a tooltip,
 * typically used to indicate protected or admin-only fields.
 */
export function Protected(props: Props) {
  const tooltipMessage =
    props.tooltipMessage ?? 'This setting is only visible to admins';

  return (
    <InputAdornment position="end">
      <Tooltip title={tooltipMessage} arrow placement="top">
        <AdminPanelSettingsOutlined color="action" />
      </Tooltip>
    </InputAdornment>
  );
}
